import { PspPaymentOptionType } from '@bp/shared/models/business';
import { Currency } from '@bp/shared/models/currencies';
import type { DTO } from '@bp/shared/models/metadata';
import { Control, FieldControlType, Mapper, Required } from '@bp/shared/models/metadata';

import { FirebasePspPaymentOptionBase } from './firebase-psp-payment-option-base';

export class FirebasePspPaymentOptionApm extends FirebasePspPaymentOptionBase {

	static override readonly type = PspPaymentOptionType.apm;

	readonly type = FirebasePspPaymentOptionApm.type;

	@Control(
		FieldControlType.chip,
		{
			list: Currency.list,
			placeholder: 'Add currency...',
		},
	)
	@Mapper(Currency)
	@Required()
	currencies!: Currency[];

	constructor(dto: DTO<FirebasePspPaymentOptionApm>) {
		super(dto);
	}

}
